import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { GiftFeedService, Variant } from '@feature/gift-feed';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GiftGradientComponent } from '../../../../libs/ui/gift-gradient';
import { CachedImagePipe } from '@utils/pipes';
import { AsyncPipe } from '@angular/common';
import { environment } from '../../../environment/environment';

@UntilDestroy()
@Component({
  selector: 'app-live-marquee',
  imports: [GiftGradientComponent, CachedImagePipe, AsyncPipe],
  templateUrl: './live-marquee.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveMarqueeComponent implements OnInit {
  public list = signal<Variant[]>([]);
  readonly #giftFeed = inject(GiftFeedService);
  protected readonly gifts = this.#giftFeed.giftsVm;
  protected readonly baseUrl = environment.BASE_URL;

  public ngOnInit() {
    this.getHistory();
    this.#giftFeed
      .messages$()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: msg => {
          console.log('New message received:', msg);
          if (msg?.type === 'gift_won') {
            this.#giftFeed.addGift(msg.prize);
          }
        },
      });
  }

  protected getHistory(): void {
    this.#giftFeed
      .getHistory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: history => {
          const events = history?.events || [];
          for (let i = events.length - 1; i >= 0; i--) {
            this.#giftFeed.addGift(events[i].prize);
          }
        },
      });
  }

  protected resolveImageSrc(path: string | null | undefined): string {
    if (!path) {
      return '';
    }

    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }

    return `${this.baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
  }
}
